<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-cloud-download
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <b-card no-body>
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <b-form-group class="mr-1 mb-md-0 d-flex">
            <b-button
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-primary"
              block
              :to="{ name: 'banner-create' }"
            >
              เพิ่มแบนเนอร์
            </b-button>
          </b-form-group>
        </div>
      </b-card-body>
      <b-table
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            >
            {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
          </div>
        </template>
        <template #cell(imgshow)="data">
          <img
            v-if="data.item.img_url"
            :src="data.item.img_url"
            alt="banner"
            class="img-fluid rounded"
            style="width: 120px; height: 60px; object-fit: cover"
          >
          <span v-else class="text-muted">ไม่มีรูป</span>
        </template>
        <template #cell(link_url)="data">
          <a
            v-if="data.item.link_url"
            :href="data.item.link_url"
            target="_blank"
            class="text-truncate d-inline-block"
            style="max-width: 200px"
          >{{ data.item.link_url }}</a>
          <span v-else class="text-muted">-</span>
        </template>
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <b-button
              v-b-tooltip.hover.v-info
              title="แก้ไข"
              variant="gradient-info"
              size="sm"
              class="mr-1"
              :to="{ path: '/Banner/edit/' + data.item._id }"
            >
              <i class="fas fa-pencil" />
            </b-button>
            <b-button
              v-b-tooltip.hover.v-danger
              title="ลบ"
              variant="gradient-danger"
              size="sm"
              @click="confirmDelete(data.item)"
            >
              <i class="fas fa-trash" />
            </b-button>
          </div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="getList()"
          />
        </b-form-group>
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getList()"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
import {
  BCard,
  BTable,
  BFormGroup,
  BFormSelect,
  BPagination,
  BButton,
  BCardBody,
  BOverlay,
  BIconCloudDownload,
  VBTooltip,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BCard,
    BTable,
    BFormGroup,
    BFormSelect,
    BPagination,
    BButton,
    BCardBody,
    BOverlay,
    BIconCloudDownload,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      show: true,
      perPage: 10,
      pageOptions: [10, 15, 20],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      items: [],
      fields: [
        { key: 'index', label: 'ลำดับ' },
        { key: 'imgshow', label: 'รูปแบนเนอร์' },
        { key: 'title', label: 'หัวข้อ' },
        { key: 'link_url', label: 'ลิงก์' },
        { key: 'order', label: 'ลำดับแสดง' },
        { key: 'actions', label: 'จัดการ' },
      ],
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.show = true
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
      }
      await this.$http
        .get('/banner/list', { params })
        .then(response => {
          this.show = false
          this.items = response.data.data || []
          this.totalRows = response.data.total || 0
        })
        .catch(() => {
          this.show = false
        })
    },
    confirmDelete(item) {
      this.$swal({
        icon: 'warning',
        title: 'ยืนยันการลบ',
        text: `ต้องการลบแบนเนอร์ "${item.title || 'รายการนี้'}" ใช่หรือไม่?`,
        showCancelButton: true,
        confirmButtonText: 'ลบ',
        cancelButtonText: 'ยกเลิก',
        customClass: {
          confirmButton: 'btn btn-danger',
          cancelButton: 'btn btn-secondary',
        },
      }).then(result => {
        if (result.isConfirmed) {
          this.deleteBanner(item._id)
        }
      })
    },
    async deleteBanner(id) {
      await this.$http
        .delete(`/banner/delete/${id}`)
        .then(() => {
          this.Success('ลบข้อมูลสำเร็จ')
          this.getList()
        })
        .catch(() => {
          this.SwalError('ลบข้อมูลไม่สำเร็จ')
        })
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>
